module.exports = __webpack_public_path__ + "img/zongyufei.b1563d37.jpg";